import { render, staticRenderFns } from "./WaitingRoomCandidate.vue?vue&type=template&id=229ad342&scoped=true"
import script from "./WaitingRoomCandidate.vue?vue&type=script&lang=js"
export * from "./WaitingRoomCandidate.vue?vue&type=script&lang=js"
import style0 from "./WaitingRoomCandidate.vue?vue&type=style&index=0&id=229ad342&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "229ad342",
  null
  
)

export default component.exports